<template>
	<div class="w-100" v-if="showComponent">

		<img
			:src="imagePreviewThumb"
			v-if="imagePreview && imagePreviewThumb"
			class="img-fluid d-block mb-3 rounded"
			style="max-width: 100%; width: 200px; height: auto; display: block;border-color:!important #e4e7ea;"
		/>

		<div class="d-flex mb-2">
			<div class="custom-control custom-radio mr-2">
				<input
					:id="`image-link-${id}`"
					type="radio"
					class="custom-control-input"
					value="link"
					@change="typeChanged('link')"
					v-model="type"
				/>
				<label class="custom-control-label" :for="`image-link-${id}`">Link</label>
			</div>

			<div class="custom-control custom-radio">
				<input
					type="radio"
					:id="`image-file-${id}`"
					class="custom-control-input"
					value="file"
					@change="typeChanged('file')"
					v-model="type"
				/>
				<label class="custom-control-label" :for="`image-file-${id}`">File</label>
			</div>
		</div>

		<template v-if="type == 'link'">
			<input
				:name="name"
				v-validate.disable="validate"
				:placeholder="placeholder"
				:class="{'form-control': true, 'is-invalid': errors.has(name)}"
				v-model.trim="link"
				@input="linkChanged"
			/>
			<span v-if="errors.has(name)" class="text-danger">{{ errors.first(name) }}</span>
		</template>

		<div v-if="type == 'file'">
			<vue-base64-file-upload
				accept="image/png, image/jpeg"
				image-class="img-thumbnail shadow img-preview"
				input-class="form-control"
				@load="fileSelected"
				placeholder="Choose an Image"
				:disable-preview="!imagePreview"
			/>
		</div>
	</div>
</template>
<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
	name: 'ImageUploader',

	components: {},

	props: {
		name: {
			type: String,
			default: () => 'image-uploader',
		},

		validate: {
			type: String,
			default: () => '',
		},

		placeholder: {
			type: String,
			default: () => '',
		},

		dropzoneOptions: {
			type: Object,
		},

		imageType: {
			type: String,
			default: () => 'link',
		},

		linkInit: {
			type: String,
			default: () => '',
		},

		imagePreview: {
			type: Boolean,
			default: true,
		},
	},

	data() {
		return {
			type: this.imageType,
			link: decodeURI(this.linkInit.trim()),
			customImageMaxSize: 3, // megabytes
			showComponent: true,
			imagePreviewThumb: null,
		}
	},

	methods: {
		imageUploaded(file, response) {
			this.$refs.chatbotimageDropzone.removeAllFiles(true)

			this.$emit('dropzoneUploaded', {
				file,
				response,
			})
		},

		rebuild() {
			this.showComponent = false

			this.$nextTick(() => {
				this.showComponent = true
				setTimeout(() => {
					this.type = this.imageType
				}, 0)
			})
		},
		linkChanged() {
			this.$emit('linkChanged', this.link)
		},

		typeChanged(type) {
			this.type = type
			this.$emit('typeChanged', this.type)
		},

		fileSelected(dataURI) {
			this.$emit('imageSelected', {
				dataURI,
			})
		},
		initImagePreview() {
			this.imagePreviewThumb = null
			if (this.linkInit && this.linkInit.length) {
				let img = new Image()

				img.src = this.linkInit

				img.onload = () => (this.imagePreviewThumb = this.linkInit)

				img.onerror = () => {
                    // set the default image
                    // img.src = this.default
				}
			}
		},
	},

	watch: {
		linkInit(newState) {
			this.link = newState
			this.initImagePreview()
		},

		imageType(newState) {
			this.type = newState
		},
	},
	computed: {
		id() {
			return window.id()
		},
	},
	created() {
		this.initImagePreview()
	},
}
</script>
